import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  InputAdornment,
  Checkbox,
  ListItemText,
  ListSubheader,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Search } from '@mui/icons-material';
import {FormControlLabel,

ClickAwayListener
} from '@mui/material';
import CustomDateRange from '../Reports/components/CustomDateRange';

// Import all CSS modules in a deterministic order BEFORE any component imports
// This ensures consistent CSS module loading order across all chunks
import styles from './complain.module.css';
import deleteModalStyles from './components/delete.module.css';
import statusChangeStyles from './components/statusChange.module.css';
import viewStudentStyles from './components/viewStudent.module.css';
import rejectComplaintStyles from './components/reject_complaint.module.css';
import TableSkeleton from 'utils/TableSkeleton';
import DeleteModal from './components/DeleteModal';
import ViewComplaint from './components/ViewComplaint';
import RejectModal from './components/RejectComplaint';
import StatusChange from './components/StatusChange';
import OtpVerificationModal from './components/OtpVerificationModal';
import MarkAsResolvedModal from './components/MarkAsResolvedModal';

import { getStatusColor } from './components/data';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { getStoredPermissionActions } from 'utils/permissionsStorage';
// import { Eye, Trash2, X, RefreshCw, Check } from 'lucide-react';
import {
  Eye,
  Trash2,
  Download,
  Hand,
  Forward,
  X,
  RefreshCw,
  GraduationCap,
  Layers,
  Users2,
  SlidersHorizontal,
  Check,
  SlidersHorizontalIcon,
  RefreshCcw
} from 'lucide-react';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import axios from 'axios';
import HoldComplaint from './components/HoldComplaint';
import ForwardComplaint from './components/ForwardComplaint';
import { set } from 'date-fns';

export const getStatusUnderReviewComplaintsColor = (status) => {
  switch (String(status || '').toLowerCase()) {
    case 'message-sent':
      return { backgroundColor: '#FDF2F8', color: '#BE185D' };
    default:
      return { backgroundColor: '#FEF3C7', color: '#D97706' };
  }
};

const getComplaintByName = (complaint) =>
  complaint?.createdByUser?.name ||
  (typeof complaint?.createdByUser === 'string' ? complaint.createdByUser : '') ||
  complaint?.dept?.createdByUser ||
  complaint?.createdByName ||
  'Not Available (N/A)';

// Ensure CSS modules are loaded in a deterministic order to avoid extract-plugin conflicts
// This array forces webpack to load CSS modules in a consistent order across all chunks
// eslint-disable-next-line no-unused-vars
const __cssOrderFix__ = [styles, deleteModalStyles, statusChangeStyles, viewStudentStyles, rejectComplaintStyles];

const HospitalComplaint = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [complaintToDelete, setComplaintToDelete] = useState(null);
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [complaintData, setComplaintData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [tabState, setTabState] = useState('pendingComplaints');
  const [error, setError] = useState(null);
  // const [isChecked, setIsChecked] = useState(false);
  const [totalComplaints, setTotalComplaints] = useState(0);
  const [resolveModal,setResolveModal]=useState(false)

  const [total, setTotal] = useState(0); // total complaints
  const [totalPages, setTotalPages] = useState(0); // derived

  const [tabCounts, setTabCounts] = useState({});
  const [complaintManagementPermission, setComplaintManagementPermission] = useState({});


  const [departmentTerm, setDepartmentTerm] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [departmentsLoading, setDepartmentsLoading] = useState(false);
  const [departmentSearch, setDepartmentSearch] = useState('');
  const [categoryTerm, setCategoryTerm] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categorySearch, setCategorySearch] = useState('');
  const [dateOpen, setDateOpen] = useState(false);
  const [range, setRange] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);

  const [holdModalOpen, setHoldModalOpen] = useState(false);
  const [forwardModalOpen, setForwardModalOpen] = useState(false);

  const [complaintId,setComplaintId] = useState('')
   const [viewDetailsLoading,setViewDetailsLoading] = useState(false)
  const [viewComplainData,setViewComplainData] = useState([])


  const [filters, setFilters] = useState({
    search: '',
    department: '',
    category: '',
    studentId: '',
    startDate: '',
    endDate: '',
    status: {
      Pending: false,
      Approved: false,
      Rejected: false
    }
  });

  const formatYmd = (d) => {
    if (!d) return '';
    const date = new Date(d);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  const formatUi = (d) =>
    d
      ? `${String(new Date(d).getDate()).padStart(2, '0')}/${String(new Date(d).getMonth() + 1).padStart(2, '0')}/${new Date(d).getFullYear()}`
      : '';

  const triggerLabel =
    filters.startDate && filters.endDate
      ? `${formatUi(filters.startDate)} — ${formatUi(filters.endDate)}`
      : 'Select Date Range';

  const applyRangeToFilters = (sel) => {
    const startDate = formatYmd(sel.startDate);
    const endDate = formatYmd(sel.endDate);
    setFilters((prev) => ({
      ...prev,
      startDate,
      endDate
    }));
    setRange([{ startDate: sel.startDate, endDate: sel.endDate, key: 'selection' }]);
  };
  const handleReset = () => {
    const resetFilters = {
      search: '',
      department: '',
      category: '',
      studentId: '',
      startDate: '',
      endDate: '',
      status: {
        Pending: false,
        Approved: false,
        Rejected: false
      }
    };
    setFilters(resetFilters); // update state
    setSearchTerm('');
    setDepartmentTerm([]);
    setCategoryTerm([]);
    setPage(0); // optional: reset page to first
  };

  const handleApply = () => {
    const updatedFilters = {
      ...filters,
      search: searchTerm, // apply searchTerm
      department: departmentTerm, // apply department(s)
      category: categoryTerm // apply category(s)
    };
    setFilters(updatedFilters);
    setPage(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters((prev) => {
        if (prev.search === searchTerm) return prev; // no change, skip
        return { ...prev, search: searchTerm };
      });
      setPage(0);
    }, 100); // 500ms debounce

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const getTabExportLabel = () => {
    if (tabState === 'resolvedComplaints') return 'resolved';
    if (tabState === 'rejectedComplaints') return 'rejected';
    return 'pending';
  };

  const allDepartmentsSelected =
    departmentOptions.length > 0 && departmentOptions.every((dept) => departmentTerm.includes(String(dept.id)));
  const hasSelectedDepartments = departmentTerm.length > 0;
  const allCategoriesSelected = categoryOptions.length > 0 && categoryOptions.every((item) => categoryTerm.includes(String(item.id)));
  const hasSelectedCategories = categoryTerm.length > 0;

  const [tabWiseCounts, setTabWiseCounts] = useState({
  pending: 0,
  hold: 0,
  forwarded: 0,
  resolved: 0,
  rejected: 0
});

  const getCategoryLabel = (complaintCategory) => {
    if (complaintCategory == null || complaintCategory === '') return 'Not Available (N/A)';

    const toName = (value) => {
      const match = categoryOptions.find((item) => String(item.id) === String(value));
      return match?.name || String(value);
    };

    if (Array.isArray(complaintCategory)) {
      const names = complaintCategory.map(toName).filter(Boolean);
      return names.length ? names.join(', ') : 'Not Available (N/A)';
    }

    if (typeof complaintCategory === 'object') {
      const id = complaintCategory?.id || complaintCategory?._id;
      const name = complaintCategory?.name || complaintCategory?.categoryName;
      if (name) return String(name);
      if (id) return toName(id);
      return 'Not Available (N/A)';
    }

    return toName(complaintCategory);
  };

  const handleExport = async () => {
    try {
      setExporting(true);

      let status = '';
      if (tabState === 'pendingComplaints') status = 'pending';
      else if (tabState === 'underReviewComplaints') status = 'in progress';
      else if (tabState === 'resolvedComplaints') status = 'resolved';
      else if (tabState === 'rejectedComplaints') status = 'rejected';

      const params = new URLSearchParams();
      const appliedDepartments = Array.isArray(filters.department)
        ? filters.department
        : filters.department
        ? [filters.department]
        : [];
      const appliedCategories = Array.isArray(filters.category) ? filters.category : filters.category ? [filters.category] : [];

      if (appliedDepartments.length) params.append('department', appliedDepartments.join(','));
      if (appliedCategories.length) params.append('category', appliedCategories.join(','));
      if (filters.search?.trim()) params.append('search', filters.search.trim());
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (status) params.append('status', status);

      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hospital/export/hospital-complaints`, {
        params,
        headers: {
          Authorization: `Bearer ${Cookies.get('Token')}`
        },
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] || 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const disposition = response.headers['content-disposition'] || '';
      const matchedFileName = disposition.match(/filename="?([^"]+)"?/i);

      link.href = url;
      link.download = matchedFileName?.[1] || `hospital_complaints_${getTabExportLabel()}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export failed:', error);
      toast.error(error.response?.data?.message || 'Failed to export complaints');
    } finally {
      setExporting(false);
    }
  };

  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value
    }));
  };









  useEffect(() => {
    const actions = getStoredPermissionActions('Hospital_Complaint');
    setComplaintManagementPermission(actions);
    console.log('Complaint Management Module Permissions:', actions);
  }, []);
  useEffect(() => {
    setPage(0);
  }, [tabState]);

  const handleSendWhatsAppMessage = async (complaint) => {
    try {
      if (!complaint?.id) {
        toast.error('Invalid complaint data');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/student_complaint/send-message/${complaint.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        },
        body: JSON.stringify({
          message: 'hey',
          userId: '68e3c91e7748a32c0d19d050' // fallback if field name differs
        })
      });

      const result = await response.json();

      if (response.ok) {
        toast.success(result?.message || 'WhatsApp message sent successfully!');
        // optionally update UI here if needed
        getCounts();
        fetchhospitalComplaints();
        console.log('✅ WhatsApp message sent:', result);
      } else {
        toast.error(result?.message || 'Failed to send WhatsApp message');
        console.error('❌ WhatsApp message error:', result);
      }
    } catch (error) {
      // Fetch doesn't have error.response; this seems like axios handling
      if (error instanceof TypeError) {
        // Network or fetch error
        toast.error('Network error: Please check your internet connection.');
        console.error('Network error:', error);
      } else {
        toast.error('Error sending WhatsApp message');
        console.error('Error sending WhatsApp message:', error);
      }
    }
  };

  //Recent Complaints

  const getCounts = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/hospital/count`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('Token')}`
        }
      });

      console.log("Hospital Complaint Counts:", res.data);

      if (res.data?.success) {
        setTabCounts(res.data.data);
      } else {
        toast.error(res.data?.message || 'Failed to fetch complaint counts');
      }
    } catch (error) {
      console.error('Error fetching complaint counts:', error);
      toast.error(error.response?.data?.message || 'Something went wrong while fetching counts');
    }
  };

  const handleMarkAsReviewed = async (complaint) => {
    // try {
    //   const response = await axios.patch(
    //     `${process.env.REACT_APP_BACKEND_URL}/student_complaint/complaint/updateStatus/${complaint.id}`,
    //     {
    //       status: 'in progress'
    //     },
    //     {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${Cookies.get('Token')}`
    //       }
    //     }
    //   );

    //   toast.success(response?.data?.message);
    //   fetchhospitalComplaints();
    // } catch (error) {
    //   // toast.error('Invalid OTP');
    //   toast.error(error.response.data.message || error.response.data.messeage || 'Something went wrong please retry');
    // }
  };

  async function fetchhospitalComplaints() {
    setLoading(true);
    try {
      // Determine status based on current tab
      let status = '';
      if (tabState === 'pendingComplaints') status = 'pending';
      else if (tabState === 'underReviewComplaints') status = 'in progress';
      else if (tabState === 'holdComplaints') status = 'hold';
      else if (tabState === 'forwardComplaints') status = 'forwarded';
      else if (tabState === 'resolvedComplaints') status = 'resolved';
      else if (tabState === 'rejectedComplaints') status = 'rejected';


console.log('CURRENT TAB:', tabState);
console.log('STATUS SENT:', status);

      const appliedSearch = filters.search?.trim() || '';
      const appliedDepartments = Array.isArray(filters.department)
        ? filters.department
        : filters.department
        ? [filters.department]
        : [];
      const appliedCategories = Array.isArray(filters.category) ? filters.category : filters.category ? [filters.category] : [];

      const searchParam = appliedSearch ? `&search=${encodeURIComponent(appliedSearch)}` : '';
      const departmentParam = appliedDepartments.length ? `&department=${encodeURIComponent(appliedDepartments.join(','))}` : '';
      const categoryParam = appliedCategories.length ? `&category=${encodeURIComponent(appliedCategories.join(','))}` : '';
      const startDateParam = filters.startDate ? `&startDate=${encodeURIComponent(filters.startDate)}` : '';
      const endDateParam = filters.endDate ? `&endDate=${encodeURIComponent(filters.endDate)}` : '';
      const baseUrl = process.env.REACT_APP_BACKEND_URL;

      const response = await fetch(`${baseUrl}/hospital/complaints/list?page=${page + 1}&limit=${rowsPerPage}&status=${encodeURIComponent(status)}${searchParam}${departmentParam}${categoryParam}${startDateParam}${endDateParam}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('Token')}`
          }
        }
      );

      const result = await response.json();
      

      if (response.ok && result?.data) {
        const pagination = result?.data?.pagination || result?.pagination || {};
        const list =
          result?.data?.data ||
          result?.data?.complaints ||
          result?.data?.items ||
          result?.data ||
          [];
        const total =
          result?.data?.total ??
          result?.data?.totalRecords ??
          result?.data?.totalComplaints ??
          result?.data?.count ??
          pagination?.total ??
          pagination?.totalRecords ??
          pagination?.totalComplaints ??
          pagination?.count ??
          result?.totalRecords ??
          result?.totalComplaints ??
          result?.count ??
          result?.total ??
          null;
        setComplaintData(Array.isArray(list) ? list : []);
        setTotalComplaints(Number.isFinite(Number(total)) ? Number(total) : (Array.isArray(list) ? list.length : 0));
        console.log('✅ complaints data:', list);
        setTabWiseCounts(prev => ({
  ...prev,
  [tabState === 'pendingComplaints' ? 'pending' 
    : tabState === 'holdComplaints' ? 'hold'
    : tabState === 'forwardComplaints' ? 'forwarded'
    : tabState === 'resolvedComplaints' ? 'resolved'
    : 'rejected']: Number(total) || list.length
}));
      } else {
        setComplaintData([]);
        setTotalComplaints(0);
        toast.error(result?.message || 'Failed to fetch complaints');
      }
    } catch (error) {
      console.error('Error fetching complaints:', error);
      toast.error('Network error: Please check your internet connection.');
    } finally {
      setLoading(false);
    }
  }

  const [debouncedSearch, setDebouncedSearch] = useState(filters.search);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(filters.search);
    }, 100);
    return () => clearTimeout(timer);
  }, [filters.search]);


  useEffect(() => {
    fetchhospitalComplaints();
  }, [
    tabState,
    page,
    rowsPerPage,
    // filters.search,
    debouncedSearch,
    filters.department,
    filters.category,
    filters.startDate,
    filters.endDate
  ]);

  useEffect(() => {
    getCounts();
  }, []);

  const getAllDepartment = async () => {
    try {
      setDepartmentsLoading(true);
      const baseUrl = process.env.REACT_APP_BACKEND_URL ;
      const response = await fetch(`${baseUrl}/hospital/department`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        }
      });
      const result = await response.json();
      const list = result?.data?.departments || result?.data?.data || result?.data || [];
      const normalized = Array.isArray(list)
        ? list
            .map((d) => {
              if (typeof d === 'string') return { id: d, name: d };
              const id = d?.id || d?._id || d?.departmentId || d?.name || d?.department || '';
              const name = d?.name || d?.department || d?.id || d?._id || '';
              return id && name ? { id: String(id), name: String(name) } : null;
            })
            .filter(Boolean)
        : [];
      setDepartmentOptions(normalized);
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartmentOptions([]);
    } finally {
      setDepartmentsLoading(false);
    }
  };

  const getAllCategories = async () => {
    try {
      setCategoriesLoading(true);
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${baseUrl}/hospital/categorylist/specific`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        }
      });
      const result = await response.json();
      const list = result?.data?.categories || result?.data?.data || result?.data || result?.categories || [];
      const normalized = Array.isArray(list)
        ? list
            .map((item) => {
              if (!item || typeof item !== 'object') return null;
              const id = item?.id || item?._id || item?.categoryId || item?.uuid;
              const name = item?.name || item?.categoryName || item?.title;
              return id && name ? { id: String(id), name: String(name) } : null;
            })
            .filter(Boolean)
        : [];
      setCategoryOptions(normalized);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategoryOptions([]);
    } finally {
      setCategoriesLoading(false);
    }
  };

  useEffect(() => {
    getAllDepartment();
    getAllCategories();
  }, []);




  // useEffect(()=>{
  //   console.error(tabState)
  // },[tabState])

  useEffect(() => {
    console.log('selectedComplaint ', selectedComplaint);
  }, [selectedComplaint]);

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get current page data
  const currentPageData = complaintData;
  const effectiveTotalComplaints = totalComplaints > 0 ? totalComplaints : currentPageData.length;
  const showingStart = effectiveTotalComplaints === 0 ? 0 : page * rowsPerPage + 1;
  const showingEnd = effectiveTotalComplaints === 0 ? 0 : page * rowsPerPage + currentPageData.length;
  const totalPageCount = Math.max(1, Math.ceil(effectiveTotalComplaints / rowsPerPage));

  // Action menu handlers
  const handleMenuOpen = (event, complaint) => {
    setAnchorEl(event.currentTarget);
    setSelectedComplaint(complaint);
    setComplaintId(complaint?.id)
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedComplaint(null);
  };

    async function fetchSingleComplainData(complainId){
      setViewDetailsLoading(false)
      try {
  
        if(!complainId){
          toast.error('missing compain ID')
        }
  
        const baseUrl = process.env.REACT_APP_BACKEND_URL;
  
        const response = await fetch(`${baseUrl}/hospital/complaint/${complainId}`,{
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('Token')}`
          }})
  
          const result = await response.json()
  
          if(result.success){
          const singleComplaindata = result?.data
          setViewComplainData(singleComplaindata)
          }
      } catch (error) {
        toast.error(error.message || `errror in fecthing detail`)
        console.error(error.message || error.message || 'error in view fetch single complain')
      }finally{
        setViewDetailsLoading(false)
      }
    }

  const handleViewDetails = (complainId) => {
    console.log("complain idddddd",complainId);
    
    setViewModalOpen(true);
    setAnchorEl(null);
    fetchSingleComplainData(complainId)
  };
  const handleChangeStatus = () => {
    setChangeStatusModalOpen(true);
    setAnchorEl(null);
  };
  const handleReject = () => {
    setRejectModalOpen(true);
    setAnchorEl(null);
  };


  const handleDeleteComplaint = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/student_complaint/deleteData/${complaintToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        }
      });
      setComplaintToDelete(null);
      setDeleteModalOpen(false);
      fetchhospitalComplaints();
      getCounts();
      if (response.ok) {
        toast.success('Complaint deleted ');
      } else {
        toast.error('Failed to delete complaint');
      }
    } catch (error) {
      console.error('Failed to delete complaint:', error);
      if (error.response && error.response.status === 404) {
        toast.error('Complaint not found');
      }
    }
  };

  return (
    <Box className={styles.container}>
      {/* Top Header Section */}
      <Box className={styles.topHeader}>
        <Box className={styles.headerLeft}>
          <Typography className={styles.mainTitle}>Hospital Complaint Management</Typography>
          <Typography className={styles.subtitle}>Track, manage and resolve hospital complaints efficiently.</Typography>
        </Box>
      </Box>

      <div className={styles.complaintheaderParents}>
        <Box className={styles.headContainer} sx={{ mb: 1 }}>
          <button
            className={`${styles.tab} ${styles.tab1} ${tabState === 'pendingComplaints' ? styles.activeTab : ''}`}
            onClick={() => setTabState('pendingComplaints')}
            disabled={loading}
          >
            <span>Pending Complaints</span>
            {tabCounts?.pending > 0 && <div className={styles.count}>{tabCounts?.pending || '0'}</div>}
          </button>

           <button
            className={`${styles.tab} ${styles.tab1} ${tabState === 'holdComplaints' ? styles.activeTab : ''}`}
            onClick={() => setTabState('holdComplaints')}
            disabled={loading}
          >
            <span>Hold Complaints</span>
            {tabCounts?.hold > 0 && <div className={styles.count}>{tabCounts?.hold || '0'}</div>}

          </button>

          <button
            className={`${styles.tab} ${styles.roomTranferTab} ${styles.relovedComplaintsTab} ${
              tabState === 'resolvedComplaints' ? styles.activeTab : ''
            }`}
            onClick={() => setTabState('resolvedComplaints')}
            disabled={loading}
            style={{ marginLeft: 8 }}
          >
            <span>Resolved Complaints</span>
            {tabCounts?.resolved > 0 && <div className={styles.count}>{tabCounts?.resolved || '0'}</div>}
          </button>

          <button
            className={`${styles.tab} ${styles.roomTranferTab} ${styles.relovedComplaintsTab} ${
              tabState === 'forwardComplaints' ? styles.activeTab : ''
            }`}
            onClick={() => setTabState('forwardComplaints')}
            disabled={loading}
            style={{ marginLeft: 8 }}
          >
            <span>Forward Complaints</span>
            {tabCounts?.forwarded > 0 && <div className={styles.count}>{tabCounts?.forwarded || '0'}</div>}
             {/* <div className={styles.count}>{tabWiseCounts?.forwarded ?? 0}</div>   */}
          </button>

          <button
            className={`${styles.tab} ${styles.roomTranferTab} ${styles.relovedComplaintsTab} ${
              tabState === 'rejectedComplaints' ? styles.activeTab : ''
            }`}
            onClick={() => setTabState('rejectedComplaints')}
            disabled={loading}
            style={{ marginLeft: 8 }}
          >
            <span>Rejected complaints</span>
            {tabCounts?.rejected > 0 && <div className={styles.count}>{tabCounts?.rejected || '0'}</div>}
          </button>
        </Box>
      </div>

      {/* Main Content Area */}
      <Box className={styles.mainContent}>
        {/* Title and Search Section */}
{/* ==========================new dilter section============================================== */}
        <div className={styles.filtersSection}>
        <div className={styles.filterHeading}>
          <h5>Filters</h5>
          <SlidersHorizontalIcon height={24} width={24} />
        </div>

        <div className={styles.inputSection}>
          {/* Search */}
          <div>
            <TextField
              size="small"
              label="Search"
              placeholder="Search by name or ID"
              className={styles.searchInput}
              value={searchTerm} // input bound to searchTerm
              onChange={(e) => setSearchTerm(e.target.value)} // updates local input only
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                )
              }}
            />
          </div>

          {/* Department */}
          <div>
            <FormControl size="small" className={styles.selectInput}>
              <InputLabel shrink id="department-label">
                Department
              </InputLabel>
              <Select
                labelId="department-label"
                multiple
                value={departmentTerm}
                onChange={(e) => {
                  const value = e.target.value;
                  const raw = typeof value === 'string' ? value.split(',').map((v) => v.trim()) : value;
                  const next = Array.isArray(raw) ? raw.filter(Boolean) : [];

                  if (next.includes('__all__')) {
                    setDepartmentTerm(hasSelectedDepartments ? [] : departmentOptions.map((dept) => String(dept.id)));
                    return;
                  }

                  setDepartmentTerm(next.filter((deptId) => departmentOptions.some((dept) => String(dept.id) === String(deptId))));
                }}
                label="Department"
                displayEmpty
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return 'All Departments';
                  }
                  return selected
                    .map((id) => departmentOptions.find((dept) => String(dept.id) === String(id))?.name)
                    .filter(Boolean)
                    .join(', ');
                }}
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 280 }
                  },
                  MenuListProps: {
                    onKeyDown: (e) => {
                      // allow typing in search without closing select
                      e.stopPropagation();
                    }
                  }
                }}
              >
                <ListSubheader disableSticky>
                  <TextField
                    size="small"
                    placeholder="Search department"
                    value={departmentSearch}
                    onChange={(e) => setDepartmentSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                    fullWidth
                  />
                </ListSubheader>
                <MenuItem value="__all__">
                  <Checkbox
                    size="small"
                    checked={hasSelectedDepartments}
                    indeterminate={!allDepartmentsSelected && departmentTerm.length > 0}
                  />
                  <ListItemText primary="Select All Departments" />
                </MenuItem>
                {departmentsLoading ? (
                  <MenuItem disabled>Loading...</MenuItem>
                ) : (
                  departmentOptions
                    .filter((dept) => String(dept?.name || '').toLowerCase().includes(departmentSearch.trim().toLowerCase()))
                    .map((dept) => (
                      <MenuItem key={dept.id} value={dept.id}>
                        <Checkbox size="small" checked={departmentTerm.includes(String(dept.id))} />
                        <ListItemText primary={dept.name} />
                      </MenuItem>
                    ))
                )}
              </Select>
            </FormControl>
          </div>

          {/* Categories */}
          <div>
            <FormControl size="small" className={styles.selectInput}>
              <InputLabel shrink id="category-label">
                Category
              </InputLabel>
              <Select
                labelId="category-label"
                multiple
                value={categoryTerm}
                onChange={(e) => {
                  const value = e.target.value;
                  const raw = typeof value === 'string' ? value.split(',').map((v) => v.trim()) : value;
                  const next = Array.isArray(raw) ? raw.filter(Boolean) : [];

                  if (next.includes('__all_categories__')) {
                    setCategoryTerm(hasSelectedCategories ? [] : categoryOptions.map((item) => String(item.id)));
                    return;
                  }

                  setCategoryTerm(next.filter((categoryId) => categoryOptions.some((item) => String(item.id) === String(categoryId))));
                }}
                label="Categories"
                displayEmpty
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return 'All Categories';
                  }
                  return selected
                    .map((id) => categoryOptions.find((item) => String(item.id) === String(id))?.name)
                    .filter(Boolean)
                    .join(', ');
                }}
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 280 }
                  },
                  MenuListProps: {
                    onKeyDown: (e) => {
                      e.stopPropagation();
                    }
                  }
                }}
              >
                <ListSubheader disableSticky>
                  <TextField
                    size="small"
                    placeholder="Search category"
                    value={categorySearch}
                    onChange={(e) => setCategorySearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                    fullWidth
                  />
                </ListSubheader>
                <MenuItem value="__all_categories__">
                  <Checkbox size="small" checked={hasSelectedCategories} indeterminate={!allCategoriesSelected && categoryTerm.length > 0} />
                  <ListItemText primary="Select All Categories" />
                </MenuItem>
                {categoriesLoading ? (
                  <MenuItem disabled>Loading...</MenuItem>
                ) : (
                  categoryOptions
                    .filter((item) => String(item?.name || '').toLowerCase().includes(categorySearch.trim().toLowerCase()))
                    .map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        <Checkbox size="small" checked={categoryTerm.includes(String(item.id))} />
                        <ListItemText primary={item.name} />
                      </MenuItem>
                    ))
                )}
              </Select>
            </FormControl>
          </div>

          {/* Date Range */}
          <div className={styles.dateContainer}>
            <button
              type="button"
              className={styles.dateTrigger}
              onClick={() => setDateOpen((o) => !o)}
              aria-expanded={dateOpen}
            >
              {triggerLabel}
            </button>
            {dateOpen && (
              <ClickAwayListener onClickAway={() => setDateOpen(false)}>
                <div className={styles.datePopoverOnlyCal}>
                  <CustomDateRange onRangeChange={applyRangeToFilters} initialRange={range} />
                </div>
              </ClickAwayListener>
            )}
          </div>

          <div className={styles.calendarActions}>
            <button type="button" className={styles.resetBtn} onClick={handleReset}>
              <RefreshCcw width={16} height={16} />
              Reset
            </button>
            <button type="button" className={styles.applyBtn} onClick={handleApply} disabled={loading}>
              <Check size={16} height={16} width={16} color="#FFF" /> {loading ? 'Loading...' : 'Apply'}
            </button>
          </div>
          
        </div>

        
        <div className={styles.statusRowParent}>
          

          <div className={styles.actionsRow}>
            <button type="button" className={styles.exportBtn} onClick={handleExport} disabled={loading || exporting}>
              <Download width={16} height={16} />
              {exporting ? 'Exporting...' : 'Export'}
            </button>
          </div>
        </div>
      </div>


        {/* Complaints Table */}
        {(tabState === 'pendingComplaints' ) && (
          <TableContainer component={Paper} className={styles.tableContainer}>
            {loading ? (
              <TableSkeleton />
            ) : (
              <Table>
                <TableHead>
                  <TableRow className={styles.tableHeaderRow}>
                    <TableCell className={styles.tableHeaderCell}>Complaint ID</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Complaint By</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Department</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Categories</TableCell>
                    {/* <TableCell className={styles.tableHeaderCell}>Room No.</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Building Name</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Floor</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Type</TableCell> */}
                    <TableCell className={styles.tableHeaderCell}>Complaint Date</TableCell>

                    {tabState === 'underReviewComplaints' && <TableCell className={styles.tableHeaderCell}>Status</TableCell>}

                    <TableCell className={styles.tableHeaderCell}>Actions</TableCell>
                    <TableCell className={styles.tableHeaderCell}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentPageData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7} style={{ textAlign: 'center', padding: '10px' }}>
                        No Complaints Found
                      </TableCell>
                    </TableRow>
                  )}

                  {tabState === 'pendingComplaints' &&
                    currentPageData.map((complaint, index) => (
                      <TableRow key={complaint.id} className={styles.tableRow}>
                        <TableCell className={styles.tableCell}>{complaint.complaintId || 'Not Available (N/A)'}</TableCell>
                        <TableCell className={styles.tableCell}>{getComplaintByName(complaint)}</TableCell>
                        {/* <TableCell className={styles.tableCell}>{complaint.studentId ? `...${complaint.studentId.slice(-6)}` : 'Not Available (N/A)'}</TableCell> */}
                        <TableCell className={styles.tableCell}>{complaint.department || 'Not Available (N/A)'}</TableCell>
                        <TableCell className={styles.tableCell}>{getCategoryLabel(complaint.category)}</TableCell>
                        {/* <TableCell className={styles.tableCell}>{complaint.roomNo || 'Not Available (N/A)'}</TableCell>
                    <TableCell className={styles.tableCell}>{complaint.buildingName || 'Not Available (N/A)'}</TableCell>

                    <TableCell className={styles.tableCell}>{complaint.floorNo || 'Not Available (N/A)'}</TableCell>
                    <TableCell className={styles.tableCell}>{complaint.type || 'Not Available (N/A)'}</TableCell> */}
                        <TableCell className={styles.tableCell}>
                          {complaint.createdAt
                            ? new Intl.DateTimeFormat('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                              }).format(new Date(complaint.createdAt))
                            : 'Not Available (N/A)'}
                        </TableCell>
                        {/* based on api cheked or unchecked and on checking api call to make it under review */}
                        {complaintManagementPermission?.approve === true ? (
                          <TableCell className={`${styles.tableCell} ${styles.btnsCell}`}>

                            <Tooltip title="Mark as Resolved" arrow placement="top">
                              <button
                                onClick={() => {
                                  setSelectedComplaint(complaint);
                                  setOtpModalOpen(true);
                                }}
                                className={styles.greenBtn}
                              >
                                <Check size={16} color="#34B53A" />
                              </button>
                            </Tooltip>
                            
                            <Tooltip title="Mark as Hold" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setHoldModalOpen(true);
                                }}
                                className={styles.holdbtn}
                              >
                                <Hand size={16} color="#f7a951ff" />
                              </button>
                            </Tooltip>

                            <Tooltip title="Mark as Forwarded" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setForwardModalOpen(true);
                                }}
                                className={styles.forwardbtn}
                              >
                                <Forward size={16} color="#d987e0ff" />
                              </button>
                            </Tooltip>

                                {/* {complaintManagementPermission?.delete === true &&
                            <Tooltip title="Mark as Rejected" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setRejectModalOpen(true);
                                }}
                                className={styles.redBtn}
                              >
                                <X size={16} color="#991B1B" />
                              </button>
                            </Tooltip>
                            } */}
                          </TableCell>
                        ) : (
                          <TableCell className={`${styles.tableCell} ${styles.btnsCell}`}>
                            <span>Not Allowed</span>
                          </TableCell>
                        )}

                        {/* <TableCell className={styles.tableCell}>
                        <Chip
                          label={complaint.status}
                          style={{
                            ...getStatusColor(complaint.status),
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                          }}
                          size="small"
                          className={styles.statusChip}
                        />
                      </TableCell> */}
                        <TableCell className={styles.tableCell}>
                          <button
                            type="button"
                            className={styles.actionBtn}
                            onClick={(e) => handleMenuOpen(e, complaint)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                handleMenuOpen(e, complaint);
                              }
                            }}
                            aria-label={`Actions for complaint ${complaint.id}`}
                          >
                            <img src="/actionBtn.svg" alt="Actions" style={{ pointerEvents: 'none' }} />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
               
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}

        {/* hold complains */}
         {(tabState === 'holdComplaints' ) && (
          <TableContainer component={Paper} className={styles.tableContainer}>
            {loading ? (
              <TableSkeleton />
            ) : (
              <Table>
                <TableHead>
                  <TableRow className={styles.tableHeaderRow}>
                    <TableCell className={styles.tableHeaderCell}>Complaint ID</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Complaint By</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Department</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Categories</TableCell>
                    {/* <TableCell className={styles.tableHeaderCell}>Room No.</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Building Name</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Floor</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Type</TableCell> */}
                    <TableCell className={styles.tableHeaderCell}>Complaint Date</TableCell>

                    {tabState === 'underReviewComplaints' && <TableCell className={styles.tableHeaderCell}>Status</TableCell>}

                    <TableCell className={styles.tableHeaderCell}>Actions</TableCell>
                    <TableCell className={styles.tableHeaderCell}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentPageData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7} style={{ textAlign: 'center', padding: '10px' }}>
                        No Complaints Found
                      </TableCell>
                    </TableRow>
                  )}

                  {tabState === 'holdComplaints' &&
                    currentPageData.map((complaint, index) => (
                      <TableRow key={complaint.id} className={styles.tableRow}>
                        <TableCell className={styles.tableCell}>{complaint.complaintId || 'Not Available (N/A)'}</TableCell>
                        <TableCell className={styles.tableCell}>{getComplaintByName(complaint)}</TableCell>
                        {/* <TableCell className={styles.tableCell}>{complaint.studentId ? `...${complaint.studentId.slice(-6)}` : 'Not Available (N/A)'}</TableCell> */}
                        <TableCell className={styles.tableCell}>{complaint.department || 'Not Available (N/A)'}</TableCell>
                        <TableCell className={styles.tableCell}>{getCategoryLabel(complaint.category)}</TableCell>
                        {/* <TableCell className={styles.tableCell}>{complaint.roomNo || 'Not Available (N/A)'}</TableCell>
                    <TableCell className={styles.tableCell}>{complaint.buildingName || 'Not Available (N/A)'}</TableCell>

                    <TableCell className={styles.tableCell}>{complaint.floorNo || 'Not Available (N/A)'}</TableCell>
                    <TableCell className={styles.tableCell}>{complaint.type || 'Not Available (N/A)'}</TableCell> */}
                        <TableCell className={styles.tableCell}>
                          {complaint.createdAt
                            ? new Intl.DateTimeFormat('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                              }).format(new Date(complaint.createdAt))
                            : 'Not Available (N/A)'}
                        </TableCell>
                        {/* based on api cheked or unchecked and on checking api call to make it under review */}
                        {complaintManagementPermission?.approve === true ? (
                          <TableCell className={`${styles.tableCell} ${styles.btnsCell}`}>

                            <Tooltip title="Mark as Resolved" arrow placement="top">
                              <button
                                onClick={() => {
                                  setSelectedComplaint(complaint);
                                  (true);
                                }}
                                className={styles.greenBtn}
                              >
                                <Check size={16} color="#34B53A" />
                              </button>
                            </Tooltip>
                            
                            {/* <Tooltip title="Mark as Hold" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setHoldModalOpen(true);
                                }}
                                className={styles.holdbtn}
                              >
                                <Hand size={16} color="#644ee5" />
                              </button>
                            </Tooltip> */}

                            <Tooltip title="Mark as Forwarded" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setForwardModalOpen(true);
                                }}
                                className={styles.forwardbtn}
                              >
                                <Forward size={16} color="#d987e0ff" />
                              </button>
                            </Tooltip>

                            {/* <Tooltip title="Mark as Rejected" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setRejectModalOpen(true);
                                }}
                                className={styles.redBtn}
                              >
                                <X size={16} color="#991B1B" />
                              </button>
                            </Tooltip> */}

                          </TableCell>
                        ) : (
                          <TableCell className={`${styles.tableCell} ${styles.btnsCell}`}>
                            <span>Not Allowed</span>
                          </TableCell>
                        )}

                        {/* <TableCell className={styles.tableCell}>
                        <Chip
                          label={complaint.status}
                          style={{
                            ...getStatusColor(complaint.status),
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                          }}
                          size="small"
                          className={styles.statusChip}
                        />
                      </TableCell> */}
                        <TableCell className={styles.tableCell}>
                          <button
                            type="button"
                            className={styles.actionBtn}
                            onClick={(e) => handleMenuOpen(e, complaint)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                handleMenuOpen(e, complaint);
                              }
                            }}
                            aria-label={`Actions for complaint ${complaint.id}`}
                          >
                            <img src="/actionBtn.svg" alt="Actions" style={{ pointerEvents: 'none' }} />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
               
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}

        {/* change data via api call of resolved ones */}

        {tabState === 'resolvedComplaints' && (
          <TableContainer component={Paper} className={styles.tableContainer}>
            {loading ? (
              <TableSkeleton />
            ) : (
              <Table>
                <TableHead>
                  <TableRow className={styles.tableHeaderRow}>
                    <TableCell className={styles.tableHeaderCell}>Complaint ID</TableCell>

                    <TableCell className={styles.tableHeaderCell}>Complaint By</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Department</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Categories</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Complaint Date</TableCell>
                    <TableCell className={styles.tableHeaderCell}></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentPageData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6} style={{ textAlign: 'center', padding: '10px' }}>
                        No Complaints Found
                      </TableCell>
                    </TableRow>
                  )}

                  {currentPageData.map((complaint, index) => (
                    <TableRow key={complaint.id} className={styles.tableRow}>
                      <TableCell className={styles.tableCell}>
                        {complaint?.complaintId ? complaint?.complaintId : 'Not Available (N/A)'}
                      </TableCell>
                      <TableCell className={styles.tableCell}>{getComplaintByName(complaint)}</TableCell>
                      <TableCell className={styles.tableCell}>{complaint.department || 'Not Available (N/A)'}</TableCell>
                      <TableCell className={styles.tableCell}>{getCategoryLabel(complaint.category)}</TableCell>
                      <TableCell className={styles.tableCell}>
                        {complaint.createdAt
                          ? new Intl.DateTimeFormat('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            }).format(new Date(complaint.createdAt))
                          : 'Not Available (N/A)'}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        <button
                          type="button"
                          className={styles.actionBtn}
                          onClick={(e) => handleMenuOpen(e, complaint)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              handleMenuOpen(e, complaint);
                            }
                          }}
                          aria-label={`Actions for complaint ${complaint.id}`}
                        >
                          <img src="/actionBtn.svg" alt="Actions" style={{ pointerEvents: 'none' }} />
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}

        {/* forward Complaints */}
        {tabState === 'forwardComplaints' && (
            <TableContainer component={Paper} className={styles.tableContainer}>
            {loading ? (
              <TableSkeleton />
            ) : (
              <Table>
                <TableHead>
                  <TableRow className={styles.tableHeaderRow}>
                    <TableCell className={styles.tableHeaderCell}>Complaint ID</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Complaint By</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Department</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Categories</TableCell>
                    {/* <TableCell className={styles.tableHeaderCell}>Room No.</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Building Name</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Floor</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Type</TableCell> */}
                    <TableCell className={styles.tableHeaderCell}>Complaint Date</TableCell>

                    {tabState === 'underReviewComplaints' && <TableCell className={styles.tableHeaderCell}>Status</TableCell>}

                    <TableCell className={styles.tableHeaderCell}>Actions</TableCell>
                    <TableCell className={styles.tableHeaderCell}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentPageData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={7} style={{ textAlign: 'center', padding: '10px' }}>
                        No Complaints Found
                      </TableCell>
                    </TableRow>
                  )}

                  {tabState === 'forwardComplaints' &&
                    currentPageData.map((complaint, index) => (
                      <TableRow key={complaint.id} className={styles.tableRow}>
                        <TableCell className={styles.tableCell}>{complaint.complaintId || 'Not Available (N/A)'}</TableCell>
                        <TableCell className={styles.tableCell}>{getComplaintByName(complaint)}</TableCell>
                        {/* <TableCell className={styles.tableCell}>{complaint.studentId ? `...${complaint.studentId.slice(-6)}` : 'Not Available (N/A)'}</TableCell> */}
                        <TableCell className={styles.tableCell}>{complaint.department || 'Not Available (N/A)'}</TableCell>
                        <TableCell className={styles.tableCell}>{getCategoryLabel(complaint.category)}</TableCell>
                        {/* <TableCell className={styles.tableCell}>{complaint.roomNo || 'Not Available (N/A)'}</TableCell>
                    <TableCell className={styles.tableCell}>{complaint.buildingName || 'Not Available (N/A)'}</TableCell>

                    <TableCell className={styles.tableCell}>{complaint.floorNo || 'Not Available (N/A)'}</TableCell>
                    <TableCell className={styles.tableCell}>{complaint.type || 'Not Available (N/A)'}</TableCell> */}
                        <TableCell className={styles.tableCell}>
                          {complaint.createdAt
                            ? new Intl.DateTimeFormat('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                              }).format(new Date(complaint.createdAt))
                            : 'Not Available (N/A)'}
                        </TableCell>
                        {/* based on api cheked or unchecked and on checking api call to make it under review */}
                          <TableCell className={`${styles.tableCell} ${styles.btnsCell}`}>
                        {complaintManagementPermission?.approve === true && (

                            <Tooltip title="Mark as Resolved" arrow placement="top">
                              <button
                                onClick={() => {
                                  setSelectedComplaint(complaint);
                                  setOtpModalOpen(true);
                                }}
                                className={styles.greenBtn}
                              >
                                <Check size={16} color="#34B53A" />
                              </button>
                            </Tooltip>
                        )}
{/* {complaintManagementPermission?.delete === true &&
(
                            <Tooltip title="Mark as Rejected" arrow placement="top">
                              <button
                                onClick={() => {
                                  console.error('ye hai cmplaint', complaint);

                                  setSelectedComplaint(complaint);
                                  setRejectModalOpen(true);
                                }}
                                className={styles.redBtn}
                              >
                                <X size={16} color="#991B1B" />
                              </button>
                            </Tooltip>)
} */}
                          </TableCell>
                       

                        {/* <TableCell className={styles.tableCell}>
                        <Chip
                          label={complaint.status}
                          style={{
                            ...getStatusColor(complaint.status),
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                          }}
                          size="small"
                          className={styles.statusChip}
                        />
                      </TableCell> */}
                        <TableCell className={styles.tableCell}>
                          <button
                            type="button"
                            className={styles.actionBtn}
                            onClick={(e) => handleMenuOpen(e, complaint)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                handleMenuOpen(e, complaint);
                              }
                            }}
                            aria-label={`Actions for complaint ${complaint.id}`}
                          >
                            <img src="/actionBtn.svg" alt="Actions" style={{ pointerEvents: 'none' }} />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
               
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}


        {/* reject complaints */}
        {tabState === 'rejectedComplaints' && (
          <TableContainer component={Paper} className={styles.tableContainer}>
            {loading ? (
              <TableSkeleton />
            ) : (
              <Table>
                <TableHead>
                  <TableRow className={styles.tableHeaderRow}>
                    <TableCell className={styles.tableHeaderCell}>Complaint ID</TableCell>

                    <TableCell className={styles.tableHeaderCell}>Complaint By</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Department</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Categories</TableCell>
                    <TableCell className={styles.tableHeaderCell}>Complaint Date</TableCell>
                    <TableCell className={styles.tableHeaderCell}></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentPageData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6} style={{ textAlign: 'center', padding: '10px' }}>
                        No Complaints Found
                      </TableCell>
                    </TableRow>
                  )}

                  {currentPageData.map((complaint, index) => (
                    <TableRow key={complaint.id} className={styles.tableRow}>
                      <TableCell className={styles.tableCell}>
                        {complaint?.complaintId ? complaint?.complaintId : 'Not Available (N/A)'}
                      </TableCell>
                      <TableCell className={styles.tableCell}>{getComplaintByName(complaint)}</TableCell>
                      <TableCell className={styles.tableCell}>{complaint.department || 'Not Available (N/A)'}</TableCell>
                      <TableCell className={styles.tableCell}>{getCategoryLabel(complaint.category)}</TableCell>
                      <TableCell className={styles.tableCell}>
                        {complaint.createdAt
                          ? new Intl.DateTimeFormat('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            }).format(new Date(complaint.createdAt))
                          : 'Not Available (N/A)'}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        <button
                          type="button"
                          className={styles.actionBtn}
                          onClick={(e) => handleMenuOpen(e, complaint)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              handleMenuOpen(e, complaint);
                            }
                          }}
                          aria-label={`Actions for complaint ${complaint.id}`}
                        >
                          <img src="/actionBtn.svg" alt="Actions" style={{ pointerEvents: 'none' }} />
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}

        {/* Custom Pagination */}
        <Box className={styles.paginationContainer}>
          {/* Left side - Showing info */}
          <Box className={styles.paginationInfo}>
            <Typography variant="body2" className={styles.paginationText}>
              Showing {showingStart}–{showingEnd} of {effectiveTotalComplaints}
            </Typography>
          </Box>

          {/* Right side - Pagination controls */}
          <Box className={styles.paginationControls}>
            <Box className={styles.paginationControls}>
              <FormControl size="small" className={styles.rowsPerPage}>
                <InputLabel>Rows per page</InputLabel>
                <Select value={rowsPerPage} label="Rows per page" onChange={handleChangeRowsPerPage}>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Page info */}
            <Typography variant="body2" className={styles.pageInfo}>
              Page {page + 1} of {totalPageCount}
            </Typography>

            {/* Navigation buttons */}
            <Box className={styles.navigationButtons}>
              <IconButton onClick={() => setPage(0)} disabled={page === 0} className={styles.paginationBtn} aria-label="First page">
                <img src="/chevrons-left.svg" alt="first page" />
              </IconButton>

              <IconButton
                onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                disabled={page === 0}
                className={styles.paginationBtn}
                aria-label="Previous page"
              >
                <img src="/chevron-left.svg" alt="previous page" />
              </IconButton>

              <IconButton
                onClick={() => setPage((prev) => Math.min(prev + 1, totalPageCount - 1))}
                disabled={page >= totalPageCount - 1}
                className={styles.paginationBtn}
                aria-label="Next page"
              >
                <img src="/chevron-right.svg" alt="next page" />
              </IconButton>

              <IconButton
                onClick={() => setPage(totalPageCount - 1)}
                disabled={page >= totalPageCount - 1}
                className={styles.paginationBtn}
                aria-label="Last page"
              >
                <img src="/chevrons-right.svg" alt="last page" />
              </IconButton>
            </Box>
          </Box>
        </Box>

      </Box>

      {/* Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          className: styles.actionsMenu,
          elevation: 8
        }}
      >
        {complaintManagementPermission?.view === true && (
          <>
            <MenuItem onClick={() => handleViewDetails(complaintId)} className={styles.menuItem}>
              {/* <Box className={styles.menuItemContent}> */}
              <Box className={styles.menuItemContent}>
                <Box className={styles.menuView}>
                  <Eye size={16} height={16} width={16} color="#1F2937" /> View Details
                </Box>
              </Box>
            </MenuItem>
          </>
        )}

        {/* options only for superAdmin */}

        {/* {selectedComplaint && selectedComplaint.status !== 'resolved' && (
          <MenuItem onClick={handleChangeStatus} className={styles.menuItem}>
            <Box className={styles.menuView}>
              <RefreshCw size={16} height={16} width={16} color="#1F2937" /> Change Status
            </Box>
          </MenuItem>
        )}
        {selectedComplaint && selectedComplaint.status !== 'rejected' && (
          <MenuItem onClick={handleReject} className={styles.menuItem}>
            <Box className={styles.menuView}>
              <X size={16} height={16} width={16} color="#1F2937" />
              Reject Complaint
            </Box>
          </MenuItem>
        )} */}

        {/* {complaintManagementPermission.delete && (
          <MenuItem
            onClick={() => {
              setComplaintToDelete(selectedComplaint);
              setDeleteModalOpen(true);
              handleMenuClose();
            }}
            className={styles.menuItem}
          >
            <Box className={styles.menuItemContent}>
              <Box className={styles.menuView}>
                <Trash2 size={16} height={16} width={16} color="#1F2937" /> Delete Complaint
              </Box>
            </Box>
          </MenuItem>
        )} */}
      </Menu>

      {/* View Complaint Modal - Placeholder for now */}
      <ViewComplaint
        open={viewModalOpen}
        onClose={() => {
          setViewModalOpen(false);
          setSelectedComplaint(null);
        }}
        complaint={viewComplainData}
        onConfirm={fetchhospitalComplaints}
        tabState={tabState}
        handleMarkAsReviewed={handleMarkAsReviewed}
        complaintManagementPermission={complaintManagementPermission}
      />
      {/* only for superadmin */}

      <DeleteModal open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} onConfirm={handleDeleteComplaint} />

      <StatusChange
        open={changeStatusModalOpen}
        onClose={() => setChangeStatusModalOpen(false)}
        onConfirm={() => {
          fetchhospitalComplaints(); // refresh the table
          setChangeStatusModalOpen(false); // close the modal
        }}
        complaint={selectedComplaint}
      />

      <RejectModal
        open={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
        onConfirm={() => {
          fetchhospitalComplaints();
          getCounts();
          setRejectModalOpen(false);
          setSelectedComplaint(null);
        }}
        complaint={selectedComplaint}
      />

      <HoldComplaint
        open={holdModalOpen}
        onClose={() => setHoldModalOpen(false)}
        onConfirm={() => {
          fetchhospitalComplaints();
          getCounts();
          setHoldModalOpen(false);
          setSelectedComplaint(null);
        }}
        complaint={selectedComplaint}
      />

      <ForwardComplaint
        open={forwardModalOpen}
        onClose={() => setForwardModalOpen(false)}
        onConfirm={() => {
          fetchhospitalComplaints();
          getCounts();
          setForwardModalOpen(false);
          setSelectedComplaint(null);
        }}
        complaint={selectedComplaint}
      />

      <OtpVerificationModal
        open={otpModalOpen}
        complaint={selectedComplaint}
        initialStatus="in progress"
        onConfirm={() => {
          fetchhospitalComplaints();
          setResolveModal(true)
          getCounts();
          setOtpModalOpen(false);
        
        }}
        onClose={() => setOtpModalOpen(false)}
      />
      <MarkAsResolvedModal
      open={resolveModal}
      complaint={selectedComplaint}
      onConfirm={() => {
        fetchhospitalComplaints();
     
        getCounts();
        setResolveModal(false);
        setSelectedComplaint(null);
      }}
      onClose={() => setResolveModal(false)}
      />
    </Box>
  );
};

export default HospitalComplaint;
